import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'user-toggle-status-modal',
	templateUrl: './user-toggle-status-modal.component.html',
	styleUrls: ['./user-toggle-status-modal.component.scss'],
})
export class UserToggleStatusModalComponent {
	@Input() isOpen = false;
	@Output() onCancel = new EventEmitter();
	@Output() onToggle = new EventEmitter();

	preventShow = false;

	toggleStatus() {
		if (this.preventShow) {
			localStorage.setItem('statusModalPreference', 'true');
		}
		this.onToggle.emit();
	}
}
